import Activite from '@/generated/classes/Activite';
export default class ActiviteExtend extends Activite {
  constructor() {
    super();
  }
}
